import React from 'react'
import Markdown from '../parts/markdown'

/**
 * Display copyright date and text
 */
const Copyrights = (props) => {
  const componentClasses = props.className ? props.className : 'text-xs tracking-wider lg:text-center'
  const prefix = props.prefix ? `${props.prefix}&nbsp;© ` : '© '
  const startYear = props.startYear ? `${props.startYear}-` : ''
  const text = props.text ? props.text : ''
  const year = props.year ? props.year : new Date().getFullYear() // Can define an hard-date or use current year by default

  return (
    <Markdown
      children={`${prefix}${startYear}${year} ${text}`}
      className={componentClasses}
    />
  )
}

export default Copyrights